import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import i18n from "../../../functions/i18next";

export default {
  props: {
    role: Object,
  },
  data() {
    return {
      deleted: false,
      error: false,
      message: "",
    };
  },
  methods: {
    /**
     * Delete the role
     */
    deleteRole() {
      let formData = new FormData();
      formData.append("id", this.role.id);

      this.$axios
        .post(baseUrl + "/deleterole", formData)
        .then((response) => {
          if (response.data) {
            this.deleted = true;
            this.error = false;
            this.message = i18n.t("manage_users.role_deleted");
            EventBus.$emit("get-all-roles");
          } else {
            this.error = true;
            this.message = i18n.t("common.something_went_wrong");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
    close() {
      EventBus.$emit("close-manage-user-actions");
    },
  },
};
